import { ApiClientProvider } from '@skylabs-digital/react-proto-kit';
import type React from 'react';
import { getApiBaseUrl } from '../config/auth.config';

interface AuthenticatedApiProviderProps {
  children: React.ReactNode;
}

/**
 * El cliente HTTP del CRUD de noten. Ya NO inyecta ningun `Authorization`.
 *
 * ## Por que se fue el interceptor
 *
 * En el modelo BFF el navegador NO tiene tokens: la credencial es la cookie
 * `HttpOnly` que puso `/api/bo/auth/login`, y una cookie `HttpOnly` es
 * justamente la que JavaScript no puede leer. El interceptor que llamaba a
 * `sessionManager.getAccessToken()` no tiene de donde sacar nada — y si lo
 * tuviera, seria un token en `localStorage`, que es lo que este cambio vino a
 * eliminar.
 *
 * Quien autentica el CRUD ahora es la MISMA cookie: el puente
 * `backend/src/api/bo/session-bridge.ts` la resuelve contra la sesion y le
 * planta el Bearer al request YA DENTRO del servidor. El navegador no
 * participa.
 *
 * ## Por que no se pasa `credentials`
 *
 * `fetch` ya manda las cookies same-origin por defecto (`credentials:
 * 'same-origin'`), y `baseUrl` es same-origin por construccion. Ponerlo en
 * `'include'` seria pedir cookies cross-origin, que es lo contrario de lo que
 * esta arquitectura quiere.
 */
export function AuthenticatedApiProvider({ children }: AuthenticatedApiProviderProps) {
  return (
    <ApiClientProvider connectorType="fetch" config={{ baseUrl: getApiBaseUrl() }}>
      {children}
    </ApiClientProvider>
  );
}
